import dataRelay from 'data-relay'
import { Project } from './project'
import { PlanSlug } from './types/enum'
import { getStore } from './store'
import { userService } from './services/useUser'
export default function (
  slug: PlanSlug,
  period: 'year' | 'month',
  totalPence: number,
  source: 'Customer Portal' | 'Mobile App',
) {
  if (Project.dataRelay) {
    const state = getStore().getState()
    const user = userService.endpoints.getUser.select({})(state as any)?.data
    const email = user?.username || user?.email

    dataRelay.sendEvent(
      {
        email,
        event: 'Sale',
        propertyString2: period,
        propertyString3: '1',
        sku: slug,
        source,
        total: period == 'year' ? totalPence / 12 : totalPence,
      },
      { apiKey: Project.dataRelay },
    )
  }
}
